import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";
export const department = createCrudVuexModule({
  namespaced: true,
  path: "/library/department",

  state: {
    recommendations: undefined,
  },
  getters: {
    recommendations(state) {
      return state.recommendations;
    },
  },
  mutations: {
    recommendations(state, value) {
      state.recommendations = value;
    },
  },
  actions: {
    async paginateRecommendation({ commit }, { pagination, level, id }, clearStateBeforeRest = false) {
      commit("isLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("recommendations", undefined);
        }
        const response = await rest.post(`/recommendation/paginate/${level}/${id}`, { pagination });
        commit("recommendations", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },
  },
});

export const departmentCategory = createCrudVuexModule({
  namespaced: true,
  path: "/library/department-category",
});

export const workspaceDepartment = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/department",
});

export const workspaceDepartmentCategory = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/department-category",
});

export const managementDepartment = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/department",
});

export const managementDepartmentCategory = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/department-category",
});
